module.exports = __webpack_public_path__ + "static/media/ramp-loading.6a2c4aa2.svg";